/**
 * Module dependencies
 */
import React from 'react';

import { LazyHydrate as Hydrator } from 'nordic/lazy';

import BestSeller from './main.bs';
import SideBar from '../../../../../components-v2/sidebar';
import BestSellerHeader from '../../../../../components-v2/header/best-seller';
import BestSellerFactory from '../../../../../components/bestseller-factory/chunk-bs-factory.desktop';

/**
 * View Component
 */
const SearchDesktopBS = (props) => {
  const namespace = 'ui-best-seller';

  return (
    <BestSeller {...props}>
      <Hydrator ssrOnly>
        <BestSellerHeader />
      </Hydrator>
      <section className={`${namespace}-content`}>
        <div className={`${namespace}-content-main`}>
          <SideBar />
          <section className={`${namespace}-content-main-components`}>
            <BestSellerFactory />
          </section>
        </div>
      </section>
    </BestSeller>
  );
};

/**
 * Inject i18n context as props into View.
 */
export default SearchDesktopBS;
